module.exports = __webpack_public_path__ + "1.jpg?bd4f97f88576a38f77515d94bf8d7c3d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/img/1.jpg
// module id = 56
// module chunks = 0